var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFeaSmallIcon01(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_743_3682)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.2305 28.7245L22.5147 26.9638C21.8472 26.7611 21.2629 26.3486 20.8483 25.7875C20.4338 25.2265 20.2111 24.5468 20.2133 23.8493V20.2183H9.77941V23.8493C9.78205 24.5472 9.55956 25.2273 9.14499 25.7887C8.73041 26.3501 8.14585 26.7629 7.47808 26.9658L1.76225 28.7265C1.61439 28.7735 1.48813 28.8716 1.40614 29.0033C1.32415 29.135 1.29179 29.2916 1.31488 29.445C1.33798 29.5985 1.41501 29.7386 1.53214 29.8403C1.64927 29.9421 1.79884 29.9987 1.95397 30.0001H28.0388C28.195 30.0002 28.3461 29.9442 28.4645 29.8423C28.5829 29.7404 28.6608 29.5994 28.6841 29.4449C28.7073 29.2904 28.6743 29.1327 28.591 29.0005C28.5078 28.8683 28.3799 28.7704 28.2305 28.7245Z",
    fill: "url(#paint0_linear_743_3682)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.3852 4.77273C22.5497 3.29252 21.328 2.06695 19.8505 1.22682C18.3729 0.386681 16.6949 -0.0364907 14.9957 0.00246644C12.4014 0.00246644 9.91334 1.03305 8.07889 2.86749C6.24445 4.70193 5.21387 7.18998 5.21387 9.78427V11.0885C5.21387 17.6097 9.77871 23.4788 14.9957 23.4788C20.0529 23.4788 24.484 17.9599 24.7514 11.0885H24.7775V9.78427C24.7772 8.0183 24.2959 6.28577 23.3852 4.77273Z",
    fill: "url(#paint1_linear_743_3682)"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_743_3682)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.7341 15.6536V8.48029C26.7341 7.96143 26.528 7.46382 26.1611 7.09693C25.7943 6.73004 25.2966 6.52393 24.7778 6.52393H5.21417C4.69531 6.52393 4.19771 6.73004 3.83082 7.09693C3.46393 7.46382 3.25781 7.96143 3.25781 8.48029V15.6536C3.25781 16.1725 3.46393 16.6701 3.83082 17.037C4.19771 17.4039 4.69531 17.61 5.21417 17.61H11.3741C11.4847 17.61 11.5935 17.5818 11.6902 17.5282C11.787 17.4746 11.8685 17.3973 11.9271 17.3035L13.1172 15.3986C13.3167 15.0804 13.5937 14.818 13.9223 14.6361C14.2509 14.4542 14.6204 14.3588 14.996 14.3588C15.3716 14.3588 15.741 14.4542 16.0696 14.6361C16.3983 14.818 16.6753 15.0804 16.8747 15.3986L18.0649 17.3035C18.1235 17.3973 18.205 17.4746 18.3017 17.5282C18.3985 17.5818 18.5073 17.61 18.6179 17.61H24.7778C25.2966 17.61 25.7943 17.4039 26.1611 17.037C26.528 16.6701 26.7341 16.1725 26.7341 15.6536Z",
    fill: "url(#paint2_linear_743_3682)",
    fillOpacity: 0.45
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_i_743_3682)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.8216 11.0884H7.17067C6.99772 11.0884 6.83185 11.0197 6.70956 10.8974C6.58726 10.7751 6.51855 10.6093 6.51855 10.4363C6.51855 10.2633 6.58726 10.0975 6.70956 9.97518C6.83185 9.85288 6.99772 9.78418 7.17067 9.78418H22.8216C22.9945 9.78418 23.1604 9.85288 23.2827 9.97518C23.405 10.0975 23.4737 10.2633 23.4737 10.4363C23.4737 10.6093 23.405 10.7751 23.2827 10.8974C23.1604 11.0197 22.9945 11.0884 22.8216 11.0884Z",
    fill: "#FFA64D",
    fillOpacity: 0.4
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_743_3682",
    x1: 1.3,
    y1: 20.2,
    x2: 24.1,
    y2: 36.4,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB347"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#E97100"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_743_3682",
    x1: 5.2,
    y1: 0,
    x2: 28.6,
    y2: 5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD194"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#E97100"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_743_3682",
    x1: 3.2,
    y1: 6.5,
    x2: 26,
    y2: 18.8,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCC80"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#E46C00"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_743_3682"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeaSmallIcon01);
export default __webpack_public_path__ + "static/media/fea-small-icon01.e79d4c544e6c7f1c5b27dfbb3714a827.svg";
export { ForwardRef as ReactComponent };